import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=20778d8a&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=20778d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20778d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
